import React, { useEffect, useState } from 'react';
import { all_routes } from '../../router/all_routes';
import Breadcrumb from '../../../core/common/Breadcrumb/breadcrumb';
import Sidebar from '../../../core/common/sidebar/sidebar';
import ImageWithBasePath from '../../../core/common/imageWithBasePath';
import { Link } from 'react-router-dom';
import axios from "axios";

const MyProfile = () => {
  const routes = all_routes;
  const [userData, setUserData] = useState<any>(null);
  const BASE_URL = process.env.REACT_APP_API_URL;

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) return;

    axios.get(`${BASE_URL}/usuarios/me`, {
      headers: { Authorization: `Bearer ${token}` }
    }).then(res => {
      setUserData(res.data);
    }).catch(err => {
      console.error("Erro ao buscar dados do usuário:", err);
    });
  }, []);

  const breadcrumbs = [
    { label: 'My Profile', link: routes.home1, active: false },
    { label: 'My Profile', active: true },
  ];

  if (!userData) {
    return (
      <div className="text-center py-5">
        <div className="spinner-border text-primary" role="status" />
        <p className="mt-3">Loading Profile...</p>
      </div>
    );
  }

  return (
    <div>
      <Breadcrumb
        title="My Profile"
        breadcrumbs={breadcrumbs}
        backgroundClass="breadcrumb-bg-01"
      />

      <div className="content">
        <div className="container">
          <div className="row">
            <div className="col-xl-3 col-lg-4">
              <Sidebar />
            </div>
            <div className="col-xl-9 col-lg-8">
              <div className="card shadow-none mb-0">
                <div className="card-header d-flex align-items-center justify-content-between">
                  <h6>My Profile</h6>
                  <div className="d-flex align-items-center justify-content-center">
                    <Link
                      to={routes.profileSettings}
                      className="p-1 rounded-circle btn btn-light d-flex align-items-center justify-content-center"
                    >
                      <i className="isax isax-edit-2 fs-14" />
                    </Link>
                  </div>
                </div>
                <div className="card-body">
                  <h6 className="fs-16 mb-3">Basic Information</h6>
                  <div className="row border-bottom pb-2 mb-3">
                    <div className="col-md-6">
                      <div className="mb-2">
                        <h6 className="fs-14">Full Name</h6>
                        <p>{userData?.nome || '-'}</p>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-2">
                        <h6 className="fs-14">Nationality</h6>
                        <p>{userData?.nacionalidade || '-'}</p>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-2">
                        <h6 className="fs-14">Email</h6>
                        <p>{userData?.email || '-'}</p>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-2">
                        <h6 className="fs-14">Phone</h6>
                        <p>{userData?.telefone || '-'}</p>
                      </div>
                    </div>
                  </div>

                  <h6 className="fs-16 mb-3">Address Information</h6>
                  <div className="row g-2">
                    <div className="col-md-12">
                      <div>
                        <h6 className="fs-14">Address</h6>
                        <p>{userData?.endereco || '-'}</p>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div>
                        <h6 className="fs-14">Country</h6>
                        <p>{userData?.pais || '-'}</p>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div>
                        <h6 className="fs-14">State</h6>
                        <p>{userData?.estado || '-'}</p>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div>
                        <h6 className="fs-14">City</h6>
                        <p>{userData?.cidade || '-'}</p>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div>
                        <h6 className="fs-14">Postal Code</h6>
                        <p>{userData?.cep || '-'}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* /My Profile */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MyProfile;
